import React from "react";

const NotFound = () => <div>Ermm... I think something wrong!</div>;

export default NotFound;
